import createId, {IdType} from "../create-id";
import type {GroupRepo} from "../GroupRepo";

type GroupStore = GroupRepo["store"];

// Steps keyed by the version they migrate from. They only get the store, so they can be tested
// without loading the repo (see __tests__/group.test.ts). Rules for new steps are in CLAUDE.md
// ("Writing migrations"): write them test-first with assertMigrationConverges.
export const groupMigrations: {[fromVersion: number]: ((store: GroupStore) => void) | undefined} = {
  0: () => {},
  // predates the determinism rule (it uses createId), see the `it.fails` test
  1: (store) => {
    const catGroupId = createId(IdType.CategoryGroup);
    store.transaction(() => {
      store.setRow("categoryGroups", catGroupId, {id: catGroupId, name: undefined});
      Object.entries(store.getTable("categories")).forEach(([id, vals]) => {
        const entryId = createId(IdType.CategoryGroupEntry);
        store.setRow("categoryGroupEntries", entryId, {
          id: entryId,
          categoryId: id,
          categoryGroupId: catGroupId,
          sortIndex: (vals as {sortIndex: string}).sortIndex,
        });
        store.setRow("categories", id, {
          ...vals,
          // the nested spread skips the excess-property check: sortIndex left the schema
          // eslint-disable-next-line unicorn/no-useless-spread
          ...{sortIndex: undefined},
        });
      });
    });
  },
};
